import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _get from "lodash/get";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/js-logging';
import { ENTITY_TYPES_CONFIG, PRODUCT_TYPES_CONFIG, ENTITY_TYPES } from './constants';
import createAdditionalDataSDK from './additional-data';
import serviceHTTPHelper from '../service-http-helper';
/**
 * Include application client meta info if accessible.
 */

var _ref = appConfig._meta || {},
    _ref$deployable = _ref.deployable,
    deployable = _ref$deployable === void 0 ? '@nerdwallet/nw-api-sdk/marketplace' : _ref$deployable,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? '' : _ref$version;

var logger = getLogger("".concat(deployable).concat(version ? "-v".concat(version) : ''));
var MARKETPLACE_API_VERSION = 1;
/**
 * Marketplace SDK.
 *
 * @param {Object} config
 * @param {Object} config.ServiceSDK - The base ServiceSDK to use.
 * @param {string} config.marketplaceBaseUrl - The Marketplace API base url.
 * @param {string} config.wpApiBaseUrl - The WP API base url.
 *
 * @return {Object} - The Marketplace SDK instance.
 */

var MarketplaceSDK = function MarketplaceSDK(_ref2) {
  var ServiceSDK = _ref2.ServiceSDK,
      config = _objectWithoutProperties(_ref2, ["ServiceSDK"]);

  if (!config || _typeof(config) !== 'object') {
    throw new Error('A config object is required to initialize MarketplaceSDK');
  } else if (!config.marketplaceBaseUrl) {
    throw new Error('config.marketplaceBaseUrl is required to initialize MarketplaceSDK');
  }
  /**
   * Get a route builder function for a specific entity type.
   *
   * @param {string} entityType - Entity type.
   *
   * @return {function} - Route builder function.
   */


  var getRouteBuilderSearch = function getRouteBuilderSearch(entityType) {
    return function (endpoint) {
      var namespace = _get(ENTITY_TYPES_CONFIG, [entityType, 'namespace']);

      return ServiceSDK.nwApiRoute(config.marketplaceBaseUrl, namespace, MARKETPLACE_API_VERSION, "".concat(endpoint, "/search"));
    };
  };
  /**
   * Get a route builder function for a specific entity type at any path.
   *
   * @param {string} entityType - Entity type.
   * @param {('search'|'autocomplete')} path - Which API to search.
   *
   * @return {function} - Route builder function.
   */


  var getRouteBuilder = function getRouteBuilder(entityType, path) {
    return function (endpoint) {
      var namespace = _get(ENTITY_TYPES_CONFIG, [entityType, 'namespace']);

      return ServiceSDK.nwApiRoute(config.marketplaceBaseUrl, namespace, MARKETPLACE_API_VERSION, "".concat(endpoint, "/").concat(path));
    };
  };
  /**
   * Get a route builder function for any entity type.
   *
   * @return {function} - Route builder function.
   */


  var getRouteBuilderUUID = function getRouteBuilderUUID() {
    return function (endpoint) {
      var route = ServiceSDK.nwApiRoute(config.marketplaceBaseUrl, 'entities', MARKETPLACE_API_VERSION, "".concat(endpoint));
      return route;
    };
  };
  /**
   * Response handler.
   *
   * The default handler returns response.data, but we want to include
   * the full response.
   *
   * @type {Object}
   */


  var responseHandler = {
    dataParser: function dataParser(response) {
      return response;
    }
  };
  /**
   * Generate a service helper for a specific entity type.
   *
   * @param {string} entityType - The entity type to fetch.
   *
   * @return {Object} - The service helper.
   */

  var getServiceSearch = function getServiceSearch(entityType) {
    return serviceHTTPHelper(ServiceSDK, getRouteBuilderSearch(entityType), responseHandler);
  };
  /**
   * Generate a service helper for fetching entity data by UUID.
   *
   * This is used to get the service helper for Marketplace entities by UUID without
   * specifying an entity type.
   *
   * @return {Object} - The service helper.
   */


  var getServiceUUID = function getServiceUUID() {
    return serviceHTTPHelper(ServiceSDK, getRouteBuilderUUID(), responseHandler);
  };
  /**
   * Get referer with fallbacks.
   *
   * @param {Object} serverRequest - Original server request.
   *
   * @return {string} - Referer.
   */


  var getReferer = function getReferer(serverRequest) {
    return serverRequest.get('Referer') || serverRequest.get('x-originating-url') || '';
  };
  /**
   * Get Marketplace data by custom payload.
   *
   * @param {Object} options
   * @param {string} options.entityType - Entity type to fetch.
   * @param {string} options.productType - Product type to fetch.
   * @param {Object} options.payload - Payload to use for fetch.
   * @param {boolean} options.includeAdditionalData - Flag to fetch additional data from WP.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain.
   * @param {boolean} options.additionalDataIds - Marketplace UUIDs for which to fetch additional data.
   * @param {Object} options.serverRequest - The current request.
   *
   * @return {Object} - Marketplace API response.
   */


  var getMarketplaceData = function getMarketplaceData(_ref3) {
    var _ref3$entityType = _ref3.entityType,
        entityType = _ref3$entityType === void 0 ? null : _ref3$entityType,
        _ref3$productType = _ref3.productType,
        productType = _ref3$productType === void 0 ? null : _ref3$productType,
        payload = _ref3.payload,
        includeAdditionalData = _ref3.includeAdditionalData,
        includeNestedAdditionalData = _ref3.includeNestedAdditionalData,
        additionalDataIds = _ref3.additionalDataIds,
        serverRequest = _ref3.serverRequest;
    var fetchMarketplaceData;
    var additionalDataSDK;
    var requestOptions = serverRequest ? {
      headers: {
        Referer: getReferer(serverRequest)
      }
    } : {};

    if (includeAdditionalData || includeNestedAdditionalData) {
      additionalDataSDK = createAdditionalDataSDK(_objectSpread({
        ServiceSDK: ServiceSDK
      }, config));
    } // If `productType` and `entityType` are set use a marketplace search endpoint
    // otherwise lookup by UUIDs endpoint.
    // @todo Remove `productType` and `entityType` once additionalData support is added to UUID lookup.


    if (productType && entityType) {
      var namespace = _get(ENTITY_TYPES_CONFIG, [entityType, 'namespace']);

      var endpoint = _get(PRODUCT_TYPES_CONFIG, [productType, 'marketplace', 'endpoint']);

      var supportedProductTypes = _get(ENTITY_TYPES_CONFIG, [entityType, 'supportedProductTypes']);

      if (!namespace) {
        throw new Error("`".concat(entityType, "` is not a valid entityType for getMarketplaceEntities(). Please use one of the following: ").concat(Object.keys(ENTITY_TYPES_CONFIG).join(', ')));
      }

      if (!endpoint) {
        throw new Error("`".concat(productType, "` is not a valid productType for getMarketplaceEntities(). Please use one of the following: ").concat(Object.keys(PRODUCT_TYPES_CONFIG).join(', ')));
      }

      if (supportedProductTypes && supportedProductTypes.indexOf(productType) < 0) {
        throw new Error("Fetching `".concat(entityType, "` is not supported for `").concat(productType, "` for getMarketplaceEntities(). Please use one of the following: ").concat(supportedProductTypes.join(', ')));
      }

      var service = getServiceSearch(entityType);
      fetchMarketplaceData = service.post(endpoint, payload, serverRequest, requestOptions);
    } else {
      var _service = getServiceUUID(); // Forward slash in `by_id/` endpoint is required by edge routing rules
      // otherwise it will redirect to `http` and cause mixed content `https` warnings during a fetch.


      fetchMarketplaceData = _service.get('by_id/', payload, serverRequest, requestOptions);
    }

    if (includeAdditionalData || includeNestedAdditionalData) {
      return additionalDataSDK.getMarketplaceDataWithAdditionalData({
        additionalDataIds: additionalDataIds,
        entityType: entityType,
        fetchMarketplaceData: fetchMarketplaceData,
        includeNestedAdditionalData: includeNestedAdditionalData,
        productType: productType,
        serverRequest: serverRequest
      }) // If additional data fetch fails, just return base marketplace response
      .catch(function (e) {
        logger.error('MarketplaceSDK: Failed to fetch additional data', _get(e, 'message'));
        return fetchMarketplaceData;
      });
    }

    return fetchMarketplaceData;
  };
  /**
   * Get Marketplace data by UUIDs
   * Product and entity type are required for additional data.
   * @todo `additionalData` support for UUID-only fetch is coming soon.
   * @todo `additionalQueryParams` support for UUID-only fetch is not currently supported. (https://nerdwallet.atlassian.net/browse/UR-203)
   * @todo `fields` support for UUID-only fetch is not currently supported. (https://nerdwallet.atlassian.net/browse/UR-203)
   * @todo `parameters` support for UUID-only fetch is not currently supported. (https://nerdwallet.atlassian.net/browse/UR-203)
   *
   * @param {Object} options
   * @param {string} options.productType
   * @param {string} options.productType - Product type to fetch.
   * @param {string} options.entityType - Entity type to fetch.
   * @param {Array} options.ids - Array of UUID's to fetch.
   * @param {boolean} options.includeAdditionalData - Flag to fetch additional data from WP.
   * @param {boolean} options.includeNestedAdditionalData - Flag to fetch additional data
   *    for supported entities up the Offer-Product-Institution chain. Used in conjunction with `includeAdditionalData`.
   * @param {Object} options.serverRequest - Original server request.
   * @param {Array} options.additionalQueryParams - Array of query params to use in addition to the default id query.
   * @param {Array} options.fields - Array of specific fields to return in the response. If omitted, all default fields will be returned.
   * @param {Object} options.parameters - Metadata used for calculating derived details
   *
   * @return {Object} - Marketplace response.
   */


  var getMarketplaceDataByIds = function getMarketplaceDataByIds(_ref4) {
    var productType = _ref4.productType,
        entityType = _ref4.entityType,
        ids = _ref4.ids,
        includeAdditionalData = _ref4.includeAdditionalData,
        includeNestedAdditionalData = _ref4.includeNestedAdditionalData,
        serverRequest = _ref4.serverRequest,
        _ref4$additionalQuery = _ref4.additionalQueryParams,
        additionalQueryParams = _ref4$additionalQuery === void 0 ? [] : _ref4$additionalQuery,
        _ref4$fields = _ref4.fields,
        fields = _ref4$fields === void 0 ? [] : _ref4$fields,
        _ref4$parameters = _ref4.parameters,
        parameters = _ref4$parameters === void 0 ? {} : _ref4$parameters;
    var payload;

    var entityTypeSingularName = _get(ENTITY_TYPES_CONFIG, [entityType, 'singular']); // If there is a `productType` and `entityType` set, use a search query payload
    // otherwise set payload to fetch by UUIDs only.
    // @todo Remove `productType` and `entityType` once additionalData support is added to UUID lookup.


    if (productType && entityType) {
      if (process.env.NODE_ENV !== 'production') {
        logger.warn('`productType` and `entityType` will be deprecated soon. They are no longer required for UUID fetch.');
      }

      payload = {
        fields: fields,
        pagination: {
          offset: 0,
          limit: ids.length
        },
        parameters: parameters,
        query: [{
          field: "".concat(entityTypeSingularName, ".id"),
          type: 'in',
          value: ids
        }].concat(_toConsumableArray(additionalQueryParams))
      };
    } else {
      payload = {
        ids: ids.join(',')
      };
    }

    return getMarketplaceData({
      entityType: entityType,
      productType: productType,
      payload: payload,
      includeAdditionalData: includeAdditionalData,
      includeNestedAdditionalData: includeNestedAdditionalData,
      additionalDataIds: ids,
      serverRequest: serverRequest
    });
  };
  /**
   * Get Marketplace data by named query.
   *
   * @return {Object} - Marketplace
   */


  var getMarketplaceDataByNamedQuery = function getMarketplaceDataByNamedQuery(_ref5) {
    var productType = _ref5.productType,
        entityType = _ref5.entityType,
        namedQuery = _ref5.namedQuery,
        payload = _ref5.payload,
        includeAdditionalData = _ref5.includeAdditionalData,
        includeNestedAdditionalData = _ref5.includeNestedAdditionalData,
        serverRequest = _ref5.serverRequest;

    if (!namedQuery) {
      throw new Error("`".concat(namedQuery, "` named query is not valid."));
    }

    return getMarketplaceData({
      entityType: entityType,
      productType: productType,
      payload: _objectSpread({}, payload, {
        named_query: namedQuery
      }),
      includeAdditionalData: includeAdditionalData,
      includeNestedAdditionalData: includeNestedAdditionalData,
      serverRequest: serverRequest
    });
  };
  /**
   * Get Autocomplete offers by search value
   *
   * @param {Object} options
   * @param {string} options.query - Text value entered by user
   * @param {string} options.namedQueryName - Selected named query
   * @param {string[]} options.searchKeys - Keys by which to search
   * @param {string[]} options.sourceFields - Offer fields to search
   * @param {string[]} options.sortKeys - Keys by which to sort the response
   * @param {number} options.maxResults - Maximum number of results to return
   * @param {boolean} options.isFuzzy - Use fuzzy search (or not)
   *
   * @return {Promise.<Object>} - A Promise that resolves with the Marketplace response.
   */


  var getAutocompleteData = function getAutocompleteData(_ref6) {
    var query = _ref6.query,
        _ref6$maxResults = _ref6.maxResults,
        maxResults = _ref6$maxResults === void 0 ? 10 : _ref6$maxResults,
        _ref6$namedQueryName = _ref6.namedQueryName,
        namedQueryName = _ref6$namedQueryName === void 0 ? null : _ref6$namedQueryName,
        _ref6$productType = _ref6.productType,
        productType = _ref6$productType === void 0 ? null : _ref6$productType,
        _ref6$searchKeys = _ref6.searchKeys,
        searchKeys = _ref6$searchKeys === void 0 ? [] : _ref6$searchKeys,
        _ref6$sourceFields = _ref6.sourceFields,
        sourceFields = _ref6$sourceFields === void 0 ? [] : _ref6$sourceFields,
        _ref6$sortKeys = _ref6.sortKeys,
        sortKeys = _ref6$sortKeys === void 0 ? [] : _ref6$sortKeys,
        _ref6$isFuzzy = _ref6.isFuzzy,
        isFuzzy = _ref6$isFuzzy === void 0 ? false : _ref6$isFuzzy;

    if (!query) {
      throw new Error('query is required.');
    }

    var endpoint = _get(PRODUCT_TYPES_CONFIG, [productType, 'marketplace', 'endpoint']);

    if (!endpoint) {
      throw new Error("`".concat(productType, "` is not a valid productType for getMarketplaceEntities(). Please use one of the following: ").concat(Object.keys(PRODUCT_TYPES_CONFIG).join(', ')));
    }

    var queryFieldsStr = searchKeys.join(',');
    var sourceFieldsStr = sourceFields.join(',');
    var sortStr = sortKeys.join(',');
    var payload = {
      query: query,
      named_query: namedQueryName,
      query_fields: queryFieldsStr,
      source_fields: sourceFieldsStr,
      sort: sortStr,
      limit: maxResults,
      is_fuzzy: isFuzzy
    };
    var service = serviceHTTPHelper(ServiceSDK, getRouteBuilder(ENTITY_TYPES.OFFERS, 'autocomplete'), responseHandler);
    return service.get(endpoint, payload);
  };

  return {
    getAutocompleteData: getAutocompleteData,
    getMarketplaceData: getMarketplaceData,
    getMarketplaceDataByIds: getMarketplaceDataByIds,
    getMarketplaceDataByNamedQuery: getMarketplaceDataByNamedQuery
  };
};

export default MarketplaceSDK;